import React, { useContext, useState } from 'react';
// AUTH
import { AuthContext } from './contexts/AuthContext';
// REACT ROUTER
import { Outlet } from "react-router-dom";
// PARTIALS
import Header from './partials/header';
// CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/nucleo.css';

function Main() {
  const { authobj } = useContext(AuthContext);
  
  return (
    <>
      { authobj && authobj.token && window.location.pathname != '/' ? <Header /> : ''}
      <Outlet />
    </>
  );
}

export default Main;